import styled from 'styled-components';
import { gradients, color } from '../../../Assets/color';
import { HoverableLink, Text, Button } from '../../Layouts';
import { colorNames, gradientNames } from '../../../Constants/colors';

// common
export const Background = styled.div`
    width: 100%;
    min-height: 100%;
    display: flex;
    justify-content: center;
    padding: 75px 0;
    position: relative;
    background: ${gradients(gradientNames.ORANGE)};
`;

export const LogoContainer = styled.div`
    position: fixed;
    top: 16px;
    left: 16px;
`;

export const FacebookAuthButton = styled(Button)`
    background-color: ${color(colorNames.FACEBOOK_BLUE)};
    text-transform: uppercase;
    border-radius: 100px;
    font-weight: 500;

    &:hover {
        background-color: rgba(68, 105, 176, 0.75);
    }
`;

export const FormContainer = styled.div`
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const FormButtonContainer = styled.div`
    width: 275px;
`;

export const Heading = styled(Text)`
    font-size: 30px;
    font-weight: bold;
`;

export const SubHeading = styled(Text)`
    font-size: 16px;
    font-weight: 300;
    text-align: center;
`;

export const SmallText = styled(Text)`
    font-size: 12px;
    font-weight: 300;
`;

export const HoverLink = styled(HoverableLink)`
    color: ${color(colorNames.WHITE)};
    font-size: 12px;
    font-weight: bold;
`;

export const SignUpLink = styled(HoverLink)`
    font-size: 16px;
`;

// sign in
export const TermsAndConditionsWrapper = styled.div`
    margin: 46px 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

// sign up
export const SignUpTermsAndConditionsWrapper = styled.div`
    margin: 33px 0 46px 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const SignUpGymContainer = styled.div`
    margin-top: 25px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ClarificationWrapper = styled.div`
    width: 100%;
    margin: 12px 0;
    display: flex;
    justify-content: center;
`;

export const ClarificationMessage = styled(Text)`
    font-weight: 100;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.75);
`;

// reset password
export const ResetPasswordHeading = styled(Heading)`
    margin-bottom: 8px;
`;

export const ResetPasswordSubheading = styled(SubHeading)`
    margin-bottom: 16px;
`;

export const ResetPasswordIconWrapper = styled.div`
    margin-bottom: 25px;
`;

export const ResetPasswordHelpInfoWrapper = styled.div`
    width: 100%;
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const TryAgainLink = styled(HoverLink)`
    font-size: 16px;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/style.js